import { partition } from 'lodash';
import { FIELD_DROPDOWN_OPTION_NAME } from './consts';
import { DropdownItem, isDropdownOption } from '@ardoq/dropdown-menu';

export const activeMultiselectOptionsCount = (
  multiselectOptions: DropdownItem[]
) => {
  const validOptions = multiselectOptions.filter(isDropdownOption);

  const [fieldOptions, batchToggles] = partition(validOptions, {
    name: FIELD_DROPDOWN_OPTION_NAME,
  });

  if (batchToggles.find(option => option.name === 'show_all')?.isActive) {
    return 'All';
  }

  if (batchToggles.find(option => option.name === 'hide_all')?.isActive) {
    return '0';
  }

  return fieldOptions.filter(({ isActive }) => isActive).length.toString();
};
